import { atom } from "jotai";
import { Refresh } from "../types/refresh";

export const refreshAtom = atom<Refresh | null>(null);
